import { useTrackingTrigger } from '@indeed/flex-tracking-context'
import React from 'react'

export const withTrackingTriggerHoc = Component => {
  return props => {
    const triggerEvent = useTrackingTrigger()
    return <Component triggerEvent={triggerEvent} {...props} />
  }
}
